import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProjectsService} from '../../../batches/projects/projects.service';
import {IProduct, IProject} from '../../../batches/projects/project';
import {FormGroup} from '@angular/forms';
import {ProductService} from '../../../viba/admin/products/products/product.service';
import {Observable} from 'rxjs';
import {AuthenticationService} from 'src/app/core/authentication.service';

@Component({
    selector: 'app-project-select',
    templateUrl: './project-select.component.html',
    standalone: false
})
export class ProjectSelectComponent implements OnInit {
  @Input() controlName = 'project';
  @Input() controlLabel = 'Project';
  @Input() id = 'project-select';
  @Input() formGroup: FormGroup;
  @Input() model: any;
  @Input() projects: IProject[];
  @Input() products: IProduct[];
  @Input() reloadProducts = false;
  @Input() showAllOption = false;
  @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() projectsChange: EventEmitter<IProject[]> = new EventEmitter<IProject[]>();
  @Output() selectionChange: EventEmitter<IProject> = new EventEmitter();
  @Output() openedChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() productsChange: EventEmitter<IProduct[]> = new EventEmitter();

  constructor(
    private projectsService: ProjectsService,
    private productService: ProductService,
    public authenticationService: AuthenticationService,
  ) {
  }

  onSelectionChanged(event) {
    this.selectionChange.emit(this.projects.find(project => project.id === event.value));
    this.modelChange.emit(event.value);

    if (this.reloadProducts) {
      this.emitProductChanges(event.value);
    }
  }

  onOpenedChanged(event) {
    this.openedChange.emit(event);
  }

  ngOnInit() {
    this.init();
    this.authenticationService.hookListActionOnOrgChange(() => {
      this.init();
    });
  }

  private init() {
    this.projectsService.getAllProjects().subscribe((projects) => {
      this.projects = projects;
      this.projectsChange.emit(projects);
      const projectId = this.formGroup ? this.formGroup.controls[this.controlName].value : this.model;

      if (typeof projectId !== 'undefined') {
        this.emitProductChanges(projectId);
      }
    });

  }

  private emitProductChanges(projectId: number) {
    this.getProducts(projectId, this.projects).subscribe(
      products => this.productsChange.emit(products)
    );
  }

  private getProducts(projectId: number, projects: IProject[]): Observable<IProduct[]> {
    if (projectId === -1) {
      return this.productService.getProductsByProjectIds(projects.map(project => project.id));
    } else {
      return this.productService.getProductsByProjectId(projectId);
    }
  }



}
